import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type AxiosResponse } from "axios";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import type CustomResponse from "~~/package/types/ResponseType";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import { CreditHistoryModel } from "~~/package/mapper/credit/model/CreditHistoryModel";
import type CreditPurchaseRequest from "~~/package/apis/credit/request/CreditPurchaseRequest";
import type { CreditPurchaseModel } from "~~/package/mapper/credit/model/CreditPurchaseModel";

export default class CreditApi {
  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getCreditHistory(page: number, size: number, creditTransactionTypes?: string[]): Promise<AxiosResponse<CustomResponse<PageModel<CreditHistoryModel>>>> {
    return this.http.get<AxiosResponse<CustomResponse<PageModel<CreditHistoryModel>>>>('/credit/history', { page, size, creditTransactionTypes },true);
  }

  public purchaseCredits(request: CreditPurchaseRequest): Promise<AxiosResponse<CustomResponse<CreditPurchaseModel>>> {
    return this.http.post<AxiosResponse<CustomResponse<CreditPurchaseModel>>, CreditPurchaseRequest>('/api/v1/subscriptions/credits', request, true);
  }
}
